import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ss-tabs',
  template: `<ss-tabs-slider [items]="items" [activeTab]="activeTab" [compact]="true" [routeSlugs]="routeSlugs" [routeBase]="routeBase" (selectedTab)="selectedTab.emit($event)"></ss-tabs-slider>`,
  standalone: false
})
export class TabsComponent {
  @Input() items: any[] = [];
  @Input() activeTab = 1;
  @Input() routeSlugs: Record<number, string> = {};
  @Input() routeBase: string[] | null = null;
  @Output() selectedTab = new EventEmitter<any>();
}
